import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {CompanyEdto} from "../../company/x-models/company-edto";
import {ServerEndpoints} from "../../../server.endpoints";
import {Tuple} from "../../../models/_generic/tuple";
import {CustomerValues} from "../../company/x-models/customer-values";
import {ContractCreateModel} from "../_models/contract-create-model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ContractHttpService {
  constructor(@Inject("BASE_URL") private baseUrl: string, private httpClient: HttpClient) {
  }

  getCompany(company: string) {
    return this.httpClient.get<CompanyEdto>(`${this.baseUrl}${ServerEndpoints.Management_Contract_GetCompany_$company$.dictReplace({company: company})}`);
  }

  getCustomerValues(company: string) {
    return this.httpClient.get<Tuple<CustomerValues, CustomerValues>>(`${this.baseUrl}${ServerEndpoints.Management_Contract_GetCustomerValues_$company$.dictReplace({company: company})}`);
  }

  update(company: string, contract: string, body: ContractCreateModel) {
    return this.httpClient.post<CompanyEdto>(`${this.baseUrl}${ServerEndpoints.Management_Contract_Update_$company$_$contract$.dictReplace({
      company: company,
      contract: contract
    })}`, body);
  }

  create(company: string, body: ContractCreateModel): Observable<CompanyEdto> {
    return this.httpClient.put<CompanyEdto>(`${this.baseUrl}${ServerEndpoints.Management_Contract_Set_$company$.dictReplace({company: company})}`, body);
  }

  delete(company: string, contract: string) {
    return this.httpClient.delete<CompanyEdto>(`${this.baseUrl}${ServerEndpoints.Management_Contract_Delete_$company$_$contract$.dictReplace({
      company: company,
      contract: contract
    })}`);
  }
}
